/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const areaService = {
  getList: (params: any) => request.get('/guidebook/district', { params }),
  getAreaById: (id: any) => request.get(`/guidebook/district/${id}`),
  createArea: (data: any) => request.post('/guidebook/district', data),
  deleteArea: (id: any) => request.delete(`/guidebook/district/${id}`),
  updateArea: (id: any, data: any) =>
    request.put(`/guidebook/district/${id}`, data)
};

export default areaService;
